var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#F7F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 30H41.6667C42.5833 30 43.3333 30.75 43.3333 31.6667V41.6667C43.3333 42.5833 42.5833 43.3333 41.6667 43.3333H31.6667C30.75 43.3333 30 42.5833 30 41.6667V31.6667C30 30.75 30.75 30 31.6667 30ZM48.3333 30H58.3333C59.25 30 60 30.75 60 31.6667V41.6667C60 42.5833 59.25 43.3333 58.3333 43.3333H48.3333C47.4167 43.3333 46.6667 42.5833 46.6667 41.6667V31.6667C46.6667 30.75 47.4167 30 48.3333 30ZM31.6667 46.6667H41.6667C42.5833 46.6667 43.3333 47.4167 43.3333 48.3333V58.3333C43.3333 59.25 42.5833 60 41.6667 60H31.6667C30.75 60 30 59.25 30 58.3333V48.3333C30 47.4167 30.75 46.6667 31.6667 46.6667ZM53.3333 46.6667C52.4167 46.6667 51.6667 47.4167 51.6667 48.3333V51.6667H48.3333C47.4167 51.6667 46.6667 52.4167 46.6667 53.3333C46.6667 54.25 47.4167 55 48.3333 55H51.6667V58.3333C51.6667 59.25 52.4167 60 53.3333 60C54.25 60 55 59.25 55 58.3333V55H58.3333C59.25 55 60 54.25 60 53.3333C60 52.4167 59.25 51.6667 58.3333 51.6667H55V48.3333C55 47.4167 54.25 46.6667 53.3333 46.6667Z",
    fill: "#C6CAC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRequest);
export default __webpack_public_path__ + "static/media/no_request.98839dc00e6690c5e42e444ba1dac6d1.svg";
export { ForwardRef as ReactComponent };